export const ACTIVITY_SHEET_CONTAINER = 'activity-sheet-container';

export function resetActivitySheetScroll() {
  const container = document.getElementById(ACTIVITY_SHEET_CONTAINER);
  if (container) {
    container.scrollTop = 0;
  }
}
